import { render, staticRenderFns } from "./TokenPurchaseModal.vue?vue&type=template&id=0b9fa8f4&scoped=true"
import script from "./TokenPurchaseModal.vue?vue&type=script&lang=js"
export * from "./TokenPurchaseModal.vue?vue&type=script&lang=js"
import style0 from "./TokenPurchaseModal.vue?vue&type=style&index=0&id=0b9fa8f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9fa8f4",
  null
  
)

export default component.exports